import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../supabase';

// /Logout: the apps' sign-out link. Signs out and shows the sign-in page.
export const Logout: React.FC = () => {
    const navigate = useNavigate();
    useEffect(() => {
        signOut().finally(() => navigate('/auth', { replace: true }));
    }, [navigate]);
    return null;
};
